import { Database } from './database';
import { Injectable } from "@angular/core";

import 'rxjs/add/operator/map';

@Injectable()
export class BllBarcode extends Database{
    eklenecek_barcode=[];

    constructor(){
        super("NL_Barcode");
    }
}


// WEBPACK FOOTER //
// ./src/providers/bll-nlbarcode.ts